import BriqInputMultiple from '@v/components/BriqInputMultiple.vue'
import BriqPriceInput from '@v/components/BriqPriceInput.vue'
import BriqIsoDurationInput from '@v/components/BriqIsoDurationInput.vue'
import OnlineTab from '@v/inventory/deals/edit/tab-online/OnlineTab.vue'
import CustomFields from '@v/settings/application/custom-fields/CustomFields.vue'
import VisitorClassifications from '@v/settings/application/visitorclassifications/VisitorClassifications.vue'
import FinanceReports from '@v/reports/FinanceReports.vue'
import InvoicesWrapper from '@v/reports/InvoicesWrapper.vue'
import BriqCountrySelect from '@v/components/BriqCountrySelect.vue'
import IntegrationsOverview from '@/vue/settings/application/integrations/IntegrationsOverview.vue'
import AdvancedSettingsWrapper from '@v/settings/application/advanced/AdvancedSettingsWrapper.vue'
import BusinessRules from '@v/schedule/BusinessRules.vue'
import BusinessUnitSwitcherModal from '@v/topbar/BusinessUnitSwitcherModal.vue'
import DebugFetch from '@v/debug/DebugFetch.vue'
import UpsertBookingWrapper from '@/vue/bookings/edit/UpsertBookingWrapper.vue'
import BriqColorInput from '@v/components/BriqColorInput.vue'
import BriqRichEditorTextarea from '@v/components/BriqRichEditorTextarea.vue'
import FunnelSettings from '@v/settings/application/funnel/FunnelSettings.vue'
import FunnelSettingsWrapper from '@v/settings/application/funnel/FunnelSettingsWrapper.vue'
import EmailSettingsWrapper from '@v/settings/application/emails/EmailSettingsWrapper.vue'
import BillingSettingsWrapper from '@v/settings/application/billing/BillingSettingsWrapper.vue'
import UpsertDealWrapper from '@v/inventory/deals/edit/UpsertDealWrapper.vue'
import ShopSettingsWrapper from '@v/settings/application/shop/ShopSettingsWrapper.vue'
import ThemeSelector from '@v/settings/application/shop/ThemeSelector.vue'
import CustomFilters from '@v/settings/application/shop/CustomFilters.vue'
import BriqNumberInputWithButtons from '@v/components/BriqNumberInputWithButtons.vue'
import SettingsMainPage from '@v/settings/application/SettingsMainPage.vue'
import UpsertScheduleItemWrapper from '@v/schedule/UpsertScheduleItemWrapper.vue'
import DashboardConfigurationWrapper from '@v/settings/application/dashboard-configuration/DashboardConfigurationWrapper.vue'
import DashboardsMenu from '@/vue/components-global/DashboardsMenu.vue'
import BookingDetailsWrapper from '@/vue/bookings/details/BookingDetailsWrapper.vue'
import BriqInventory from '@/vue/inventory/BriqInventory.vue'
import BriqPlanboard from '@/vue/planboard/BriqPlanboard.vue'
import BookingsOverview from '@v/bookings/BookingsOverview.vue'

// These components are registered globally for now
// Once we are far enough so that Briq app pages can be split with vue router, we can remove these.

export default {
  BriqInputMultiple,
  BriqPriceInput,
  BriqIsoDurationInput,
  OnlineTab,
  CustomFields,
  VisitorClassifications,
  FinanceReports,
  InvoicesWrapper,
  BriqCountrySelect,
  IntegrationsOverview,
  AdvancedSettingsWrapper,
  BusinessRules,
  BusinessUnitSwitcherModal,
  DebugFetch,
  UpsertBookingWrapper,
  BriqColorInput,
  BriqRichEditorTextarea,
  FunnelSettings,
  FunnelSettingsWrapper,
  EmailSettingsWrapper,
  BillingSettingsWrapper,
  UpsertDealWrapper,
  ShopSettingsWrapper,
  ThemeSelector,
  CustomFilters,
  BriqNumberInputWithButtons,
  SettingsMainPage,
  UpsertScheduleItemWrapper,
  DashboardConfigurationWrapper,
  DashboardsMenu,
  BookingDetailsWrapper,
  BriqInventory,
  BriqPlanboard,
  BookingsOverview
}
